var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowthEngine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.75 16.5C19.75 16.9142 19.4142 17.25 19 17.25H1C0.585786 17.25 0.25 16.9142 0.25 16.5C0.25 16.0858 0.585786 15.75 1 15.75H1.75V9.75C1.75 9.33579 2.08579 9 2.5 9H4.75C5.16421 9 5.5 9.33579 5.5 9.75V15.75H7V5.25C7 4.83579 7.33579 4.5 7.75 4.5H10.75C11.1642 4.5 11.5 4.83579 11.5 5.25V15.75H13V0.75C13 0.335786 13.3358 0 13.75 0H17.5C17.9142 0 18.25 0.335786 18.25 0.75V15.75H19C19.4142 15.75 19.75 16.0858 19.75 16.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowthEngine);
export default __webpack_public_path__ + "static/media/growth-engine.5763991c5b8df1e1b8d85c2085019d9b.svg";
export { ForwardRef as ReactComponent };